import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const GridFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function GridFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M18 1.5H6c-2.21 0-4 1.79-4 4v13c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4v-13c0-2.21-1.79-4-4-4Zm1 4v2h-5.5v-3H18c.55 0 1 .45 1 1Zm-5.5 5H19v3h-5.5v-3Zm-3 3H5v-3h5.5v3ZM6 4.5h4.5v3H5v-2c0-.55.45-1 1-1Zm-1 14v-2h5.5v3H6c-.55 0-1-.45-1-1Zm13 1h-4.5v-3H19v2c0 .55-.45 1-1 1Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default GridFilled;